// 확인 시트 — 데스크톱은 센터 다이얼로그, ≤768 은 바텀시트 (시안 A4-S/A5-S).
// props: { open, title, headline, sub, hint, confirmLabel, onConfirm, onClose, children }
// SheetFrame 은 같은 껍데기를 쓰는 다른 시트(MonthNav 월 선택)용 named export.
import React, { useEffect } from 'react';
import { T, R } from '../../theme';
import { useIsMobile } from '../../../utils/useMobile';
import { useT } from '../../../i18n/I18nProvider';

var dim = { position: 'fixed', inset: 0, background: 'rgba(15,23,42,.5)', zIndex: 9990, display: 'flex', justifyContent: 'center' };
var panel = { background: T.card, color: T.ink, width: '100%', overflow: 'clip', boxShadow: '0 18px 40px rgba(0,0,0,.28)', display: 'flex', flexDirection: 'column', maxHeight: '90vh' };
var hdr = { display: 'flex', alignItems: 'center', gap: 10, padding: '13px 16px', borderBottom: '1px solid ' + T.bd, background: T.head };
var hdrTitle = { fontSize: 14, fontWeight: 800, letterSpacing: '-.2px', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' };
var closeBtn = { marginInlineStart: 'auto', color: T.faint, fontSize: 15, lineHeight: 1, flex: 'none', border: 0, background: 'none', cursor: 'pointer', fontFamily: 'inherit' };
var body = { padding: '14px 16px 16px', display: 'flex', flexDirection: 'column', gap: 11, overflowY: 'auto' };
var grab = { width: 36, height: 4, borderRadius: 2, background: T.line, margin: '8px auto 0' };
var headlineStyle = { fontSize: 14, fontWeight: 800, letterSpacing: '-.25px', color: T.ink };
var subStyle = { fontSize: 12, color: T.muted, marginTop: 3, lineHeight: 1.6 };
var tip = { display: 'flex', gap: 9, padding: '10px 12px', borderRadius: R.md, background: T.accentTint,
  border: '1px solid ' + T.accentBd, fontSize: 11.5, color: T.accentPress, lineHeight: 1.55 };
var row = { display: 'flex', gap: 10 };
var btn = { flex: 1, height: 42, borderRadius: R.md, fontSize: 13.5, fontWeight: 700, cursor: 'pointer',
  fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: 0 };

export function SheetFrame(props) {
  var isMobile = useIsMobile();
  var onClose = props.onClose;
  useEffect(function () {
    if (!props.open) return undefined;
    var h = function (e) { if (e.key === 'Escape' && onClose) onClose(); };
    document.addEventListener('keydown', h);
    return function () { document.removeEventListener('keydown', h); };
  }, [props.open, onClose]);
  if (!props.open) return null;
  var dimStyle = Object.assign({}, dim, isMobile ? { alignItems: 'flex-end' } : { alignItems: 'center', padding: 24 });
  var panelStyle = Object.assign({}, panel, isMobile
    ? { borderRadius: '16px 16px 0 0' }
    : { maxWidth: 440, borderRadius: R.lg });
  return (<div className="ss-dim" style={dimStyle} onClick={function (e) { if (e.target === e.currentTarget && onClose) onClose(); }}>
    <div className="ss-sheet" role="dialog" aria-modal="true" aria-label={props.title || ''} style={panelStyle}>
      {isMobile ? <div style={grab} /> : null}
      <div style={isMobile ? Object.assign({}, hdr, { background: T.card, borderBottom: 0, paddingBottom: 4 }) : hdr}>
        <b style={hdrTitle}>{props.title}</b>
        {isMobile ? null : <button type="button" style={closeBtn} aria-label={props.closeLabel || 'close'} onClick={onClose}>✕</button>}
      </div>
      <div style={body}>{props.children}</div>
    </div>
  </div>);
}

function ConfirmSheet(props) {
  var t = useT();
  return (<SheetFrame open={props.open} title={props.title} onClose={props.onClose} closeLabel={t('actionClose')}>
    {props.headline || props.sub ? (<div>
      {props.headline ? <div style={headlineStyle}>{props.headline}</div> : null}
      {props.sub ? <p style={subStyle}>{props.sub}</p> : null}
    </div>) : null}
    {props.children}
    {props.hint ? <div style={tip}>{props.hint}</div> : null}
    <div style={row}>
      <button type="button" style={Object.assign({}, btn, { background: T.card, border: '1px solid ' + T.bd, color: T.body })}
        onClick={props.onClose}>{t('actionCancel')}</button>
      <button type="button" style={Object.assign({}, btn, { background: T.navy, border: '1px solid ' + T.navy, color: T.card, flex: 2 })}
        onClick={props.onConfirm}>{props.confirmLabel || t('actionConfirm')}</button>
    </div>
  </SheetFrame>);
}

export default ConfirmSheet;
